import { createListCollection, Select } from '@skin-seoul/design-system';
import { CLASSNAME, detectBrowserLanguage, getLanguageCookie, setLanguageCookie } from '@skin-seoul/service';
import React, { useMemo } from 'react';
import { GOOGLE_TRANSLATE_LANGUAGE_OPTIONS, type LanguageOption } from './constants';
type TranslateLanguageSelectProps = {
  value?: string;
  onChange?: (language: string) => void;
  applyImmediately?: boolean;
};
export const TranslateLanguageSelect = ({
  value,
  onChange,
  applyImmediately = true
}: TranslateLanguageSelectProps) => {
  const items = useMemo<LanguageOption[]>(() => GOOGLE_TRANSLATE_LANGUAGE_OPTIONS.map((o: LanguageOption) => ({
    value: o.value,
    label: o.label
  })), []);
  const collection = useMemo(() => createListCollection<LanguageOption>({
    items
  }), [items]);
  const browserLanguage = useMemo(() => detectBrowserLanguage(), []);
  const selected = value ?? getLanguageCookie() ?? browserLanguage;
  return <Select.Root multiple={false} deselectable={false} collection={collection} onValueChange={({
    value
  }) => {
    const lang = value[0];
    onChange?.(lang);
    if (applyImmediately) {
      setLanguageCookie(lang);
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('ss:user-language-change', {
          detail: lang
        }));
      }
    }
  }} value={[selected]} size="sm" data-sentry-element="Select.Root" data-sentry-component="TranslateLanguageSelect" data-sentry-source-file="TranslateLanguageSelect.tsx">
      <Select.HiddenSelect data-sentry-element="Select.HiddenSelect" data-sentry-source-file="TranslateLanguageSelect.tsx" />
      <Select.Label className={CLASSNAME.NOT_TRANSLATE} textStyle="paragraph.small" color="neutral.900" data-sentry-element="Select.Label" data-sentry-source-file="TranslateLanguageSelect.tsx">
        Language Setting
      </Select.Label>
      <Select.Control data-sentry-element="Select.Control" data-sentry-source-file="TranslateLanguageSelect.tsx">
        <Select.Trigger height="40px" border="1px solid" borderColor="neutral.900" _hover={{
        borderColor: 'neutral.300'
      }} data-sentry-element="Select.Trigger" data-sentry-source-file="TranslateLanguageSelect.tsx">
          <Select.ValueText className={CLASSNAME.NOT_TRANSLATE} textStyle="paragraph.small" color="neutral.900" data-sentry-element="Select.ValueText" data-sentry-source-file="TranslateLanguageSelect.tsx" />
        </Select.Trigger>
        <Select.IndicatorGroup data-sentry-element="Select.IndicatorGroup" data-sentry-source-file="TranslateLanguageSelect.tsx">
          <Select.Indicator color="neutral.900" data-sentry-element="Select.Indicator" data-sentry-source-file="TranslateLanguageSelect.tsx" />
        </Select.IndicatorGroup>
      </Select.Control>
      <Select.Positioner data-sentry-element="Select.Positioner" data-sentry-source-file="TranslateLanguageSelect.tsx">
        <Select.Content maxHeight="30dvh" boxShadow="0px 0px 10px 0px rgba(0, 0, 0, 0.1)" data-sentry-element="Select.Content" data-sentry-source-file="TranslateLanguageSelect.tsx">
          {collection.items.map((country: LanguageOption) => <Select.Item padding="12px 8px" key={country.value} item={country} className={CLASSNAME.NOT_TRANSLATE} _selected={{
          backgroundColor: 'neutral.100/60'
        }}>
              {country.label}
              <Select.ItemIndicator />
            </Select.Item>)}
        </Select.Content>
      </Select.Positioner>
    </Select.Root>;
};
export default TranslateLanguageSelect;